<section class="mu-home">
  <div class="container">
    <div class="row">
      <div class="col-lg-12 offset-lg-0 col-md-11 offset-md-1 col-12">
        <div class="col-12">
          <div class="row">
            <div class="col-md-12 col-12">
              <div class="col-md-12 mb-2 empl-tptxt"><h3>My Profile</h3></div>
              <div class="col-md-12">
                <div class="vtabs1">
                  <div class="row mx-0">
                    <div class="col-md-3 col-sm-12 px-0">
                      <div class="d-flex align-items-start">
                        <div
                          class="nav flex-column nav-pills w-100"
                          id="v-pills-tab"
                          role="tablist"
                          aria-orientation="vertical"
                        >
                          <li
                            class="nav-link active"
                            id="v-pills-home-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-home"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-home"
                            aria-selected="true"
                          >
                            Personal Information
                          </li>
                          <li
                            class="nav-link"
                            id="v-pills-profile-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-profile"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-profile"
                            aria-selected="false"
                          >
                            Employment Details
                          </li>
                          <li
                            class="nav-link"
                            id="v-pills-messages-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#v-pills-messages"
                            type="button"
                            role="tab"
                            aria-controls="v-pills-messages"
                            aria-selected="false"
                          >
                            Benefits & Statutory Details
                          </li>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-9 col-12 main-tbscontdv">
                      <div class="tab-content" id="v-pills-tabContent" style="padding: 10px">
                        <div
                          class="tab-pane fade show active"
                          id="v-pills-home"
                          role="tabpanel"
                          aria-labelledby="v-pills-home-tab"
                        >
                          <div class="warpper">
                            <input class="radio" id="one" name="group" type="radio" checked />
                            <input class="radio" id="two" name="group" type="radio" />
                            <div class="tabs">
                              <label class="tab" id="one-tab" for="one">Basic Data</label>
                              <label class="tab" id="two-tab" for="two">Contact Details</label>
                            </div>
                            <div class="panels">
                              <form [formGroup]="employeeBasicDataForm">
                                <div class="panel" id="one-panel">
                                  <div class="row">
                                    <div class="col-md-9">
                                      <div class="row">
                                        <div class="col-6">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >Name<sup>*</sup></label
                                            >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="Name"
                                              formControlName="name"
                                              [ngClass]="{
                                                'is-invalid': basicData_f['name'].errors && basicData_f['name'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="name"
                                              [form]="employeeBasicDataForm"
                                              [error]="{
                                                required: 'This is a mandatory field, Kindly enter EE Name',
                                                minLength: 'Name should have a minimum of 3 characters',
                                                maxLength: 'Name should not exceed 150 characters',
                                                pattern: 'Name should contain only alphabets and spaces'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >Date of Joining <sup>*</sup></label
                                            >
                                            <input
                                              type="date"
                                              class="form-control"
                                              onFocus="this.showPicker()"
                                              formControlName="doj"
                                              [ngClass]="{
                                                'is-invalid': basicData_f['doj'].errors && basicData_f['doj'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="doj"
                                              [form]="employeeBasicDataForm"
                                              [error]="{
                                                required: 'This is a mandatory field, Kindly select Date of Joining'
                                              }"
                                            ></app-validation>
                                          </div>
                                        </div>
                                        <div class="col-6">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >Employee ID <sup>*</sup></label
                                            >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="XXXXX"
                                              formControlName="employeeCode"
                                              [ngClass]="{
                                                'is-invalid':
                                                  basicData_f['employeeCode'].errors &&
                                                  basicData_f['employeeCode'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="employeeCode"
                                              [form]="employeeBasicDataForm"
                                              [error]="{
                                                required: 'This is a mandatory field, Kindly enter Employee ID'
                                              }"
                                            ></app-validation>
                                          </div>
                                        </div>
                                        <div class="col-12 mb-3">
                                          <div class="col-12 mb-2 mt-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >Gender <sup>*</sup></label
                                            >
                                          </div>
                                          <ng-container *ngFor="let gender of genders">
                                            <div class="form-check form-check-inline">
                                              <input
                                                class="form-check-input"
                                                type="radio"
                                                id="genderRadio"
                                                value="{{ gender?.key1.toUpperCase() }}"
                                                formControlName="gender"
                                                [ngClass]="{
                                                  'is-invalid':
                                                    basicData_f['gender'].errors && basicData_f['gender'].touched
                                                }"
                                              />
                                              <label class="form-check-label" for="genderRadio">{{
                                                gender?.key2
                                              }}</label>
                                            </div>
                                          </ng-container>
                                          <app-validation
                                            field="gender"
                                            [form]="employeeBasicDataForm"
                                            [error]="{ required: 'This is a mandatory field, Kindly select Gender' }"
                                          ></app-validation>
                                        </div>
                                        <div class="col-6">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >Date of Birth <sup>*</sup></label
                                            >
                                            <input
                                              type="date"
                                              class="form-control"
                                              onFocus="this.showPicker()"
                                              formControlName="dob"
                                              max="{{ today }}"
                                              [ngClass]="{
                                                'is-invalid': basicData_f['dob'].errors && basicData_f['dob'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="dob"
                                              [form]="employeeBasicDataForm"
                                              [error]="{
                                                required: 'This is a mandatory field, Kindly select Date of Birth',
                                                invalidDob:
                                                  'The age you have mentioned is less than 14 years. Recheck and enter correct DOB.'
                                              }"
                                            ></app-validation>
                                          </div>
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >Marital Status <sup>*</sup></label
                                            >
                                            <select
                                              class="form-select"
                                              aria-label="Default select example"
                                              formControlName="maritalStatus"
                                              [ngClass]="{
                                                'is-invalid':
                                                  basicData_f['maritalStatus'].errors &&
                                                  basicData_f['maritalStatus'].touched
                                              }"
                                            >
                                              <option [disabled]="true" selected value="">Select Marital Status</option>
                                              <option
                                                *ngFor="let maritalStatus of maritalStatuses"
                                                value="{{ maritalStatus?.key1.toUpperCase() }}"
                                              >
                                                {{ maritalStatus?.key2 }}
                                              </option>
                                            </select>
                                            <app-validation
                                              field="maritalStatus"
                                              [form]="employeeBasicDataForm"
                                              [error]="{
                                                required: 'This is a mandatory field, Kindly select Marital Status'
                                              }"
                                            ></app-validation>
                                          </div>
                                        </div>
                                        <div class="col-6">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >E-Mail ID - Primary <sup>*</sup></label
                                            >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="XXXXX"
                                              formControlName="emailId"
                                              [ngClass]="{
                                                'is-invalid':
                                                  basicData_f['emailId'].errors && basicData_f['emailId'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="emailId"
                                              [form]="employeeBasicDataForm"
                                              [error]="{
                                                required: 'This is a mandatory field, Kindly enter E-Mail ID - Primary',
                                                minLength: 'E-Mail ID should have a minimum of 5 characters',
                                                maxLength: 'E-Mail ID should not exceed 50 characters',
                                                email: 'Invalid email format'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">Nationality</label>
                                            <!--select
                                              class="form-select"
                                              aria-label="Default select example"
                                              formControlName="nationality"
                                            >
                                              <option [disabled]="true" selected value="">Select Nationality</option>
                                              <option
                                                *ngFor="let nationality of nationalities"
                                                value="{{ nationality?.key1.toUpperCase() }}"
                                              >
                                                {{ nationality?.key2 }}
                                              </option>
                                            </select-->
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="XXXXX"
                                              formControlName="nationality"
                                              [ngClass]="{
                                                'is-invalid':
                                                  basicData_f['emailId'].errors && basicData_f['emailId'].touched
                                              }"
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="col-12 text-end mt-3">
                                      <button
                                        type="submit"
                                        class="btn-save"
                                        (click)="updateEmployeeBasicData()"
                                        [disabled]="employeeBasicDataForm.invalid"
                                      >
                                        SAVE
                                      </button>
                                      <button
                                        type="submit"
                                        class="btn-discard"
                                        (click)="reset(employeeBasicDataForm, initialBasicData)"
                                      >
                                        DISCARD
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                              <form [formGroup]="employeeContactDataForm">
                                <div class="panel" id="two-panel">
                                  <div class="row">
                                    <div class="col-md-12">
                                      <div class="row">
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label"
                                              >E-Mail ID - Secondary</label
                                            >
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder="XXXXX"
                                              formControlName="secondaryEmailId"
                                              [ngClass]="{
                                                'is-invalid':
                                                  contactData_f['secondaryEmailId'].errors &&
                                                  contactData_f['secondaryEmailId'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="secondaryEmailId"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                minLength: 'Secondary E-Mail ID should have a minimum of 5 characters',
                                                maxLength: 'Secondary E-Mail ID should not exceed 50 characters',
                                                email: 'Invalid email format'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mobile-number-block">
                                            <label for="exampleFormControlInput1" class="form-label text-nowrap"
                                              >Primary Mobile Number</label
                                            >
                                            <div class="mobile-input-group">
                                              <select
                                                formControlName="primaryCountryCode"
                                                class="form-control"
                                                [ngClass]="{ 'is-invalid': contactData_f?.['primaryCountryCode']?.errors && (contactData_f?.['primaryCountryCode']?.touched) }"
                                              >
                                                <option *ngFor="let countryCode of countryCodes">
                                                  {{ countryCode.dialCode }}
                                                </option>
                                              </select>

                                              <input
                                                type="text"
                                                placeholder=""
                                                value="+911234567890"
                                                formControlName="primaryMobileNumber"
                                                class="form-control form-control-fixed-phone mobile-number-input"
                                                [ngClass]="{ 'is-invalid': contactData_f?.['primaryMobileNumber']?.errors && (contactData_f?.['primaryMobileNumber']?.touched) }"
                                              />
                                            </div>
                                            <app-validation
                                              field="primaryCountryCode"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                countryCodeInvalid:
                                                  'This is a mandatory field, Kindly select Country code'
                                              }"
                                            >
                                            </app-validation>
                                            <app-validation
                                              field="primaryMobileNumber"
                                              [form]="employeeContactDataForm"
                                              [error]="{ pattern: 'Please enter a 10-digit mobile number' }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mobile-number-block">
                                            <label for="exampleFormControlInput1" class="form-label text-nowrap"
                                              >Secondary Mobile Number</label
                                            >
                                            <div class="mobile-input-group">
                                              <select
                                                formControlName="secondaryCountryCode"
                                                class="form-control"
                                                [ngClass]="{ 'is-invalid': contactData_f?.['secondaryCountryCode']?.errors && (contactData_f?.['secondaryCountryCode']?.touched) }"
                                              >
                                                <option *ngFor="let countryCode of countryCodes">
                                                  {{ countryCode.dialCode }}
                                                </option>
                                              </select>

                                              <input
                                                type="text"
                                                placeholder=""
                                                formControlName="secondaryMobileNumber"
                                                class="form-control form-control-fixed-phone mobile-number-input"
                                                [ngClass]="{ 'is-invalid': contactData_f?.['secondaryMobileNumber']?.errors && (contactData_f?.['secondaryMobileNumber']?.touched) }"
                                              />
                                            </div>
                                            <app-validation
                                              field="secondaryCountryCode"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                countryCodeInvalid:
                                                  'This is a mandatory field, Kindly select Country code'
                                              }"
                                            >
                                            </app-validation>
                                            <app-validation
                                              field="secondaryMobileNumber"
                                              [form]="employeeContactDataForm"
                                              [error]="{ pattern: 'Please enter a 10-digit mobile number' }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-12">
                                      <div class="row">
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">Door No</label>
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder=""
                                              formControlName="doorNo"
                                              [ngClass]="{
                                                'is-invalid':
                                                  contactData_f['doorNo'].errors && contactData_f['doorNo'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="doorNo"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                minLength: 'Door No should have a minimum of 1 characters',
                                                maxLength: 'Door No should not exceed 10 characters'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">Street Name</label>
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder=""
                                              formControlName="streetName"
                                              [ngClass]="{
                                                'is-invalid':
                                                  contactData_f['streetName'].errors &&
                                                  contactData_f['streetName'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="streetName"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                minLength: 'Street Name should have a minimum of 3 characters',
                                                maxLength: 'Street Name should not exceed 25 characters'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">Area Name</label>
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder=""
                                              formControlName="areaName"
                                              [ngClass]="{
                                                'is-invalid':
                                                  contactData_f['areaName'].errors && contactData_f['areaName'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="areaName"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                minLength: 'Area Name should have a minimum of 3 characters',
                                                maxLength: 'Area Name should not exceed 25 characters'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">City / Town</label>
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder=""
                                              formControlName="city"
                                              [ngClass]="{
                                                'is-invalid':
                                                  contactData_f['city'].errors && contactData_f['city'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="city"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                minLength: 'City should have a minimum of 3 characters',
                                                maxLength: 'City name should not exceed 25 characters'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">State</label>
                                            <select
                                              class="form-select"
                                              aria-label="Default select example"
                                              formControlName="state"
                                            >
                                              <option [disabled]="true" selected value="">Select State</option>
                                              <option *ngFor="let state of states" value="{{ state?.key1 }}">
                                                {{ state?.key2 }}
                                              </option>
                                            </select>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">Country</label>
                                            <select
                                              class="form-select"
                                              aria-label="Default select example"
                                              formControlName="country"
                                            >
                                              <option *ngFor="let country of countries" [value]="country.name">
                                                {{ country.name }}
                                              </option>
                                            </select>
                                          </div>
                                        </div>
                                        <div class="col-4">
                                          <div class="mb-3">
                                            <label for="exampleFormControlInput1" class="form-label">Pincode</label>
                                            <input
                                              type="text"
                                              class="form-control"
                                              placeholder=""
                                              formControlName="pinCode"
                                              [ngClass]="{
                                                'is-invalid':
                                                  contactData_f['pinCode'].errors && contactData_f['pinCode'].touched
                                              }"
                                            />
                                            <app-validation
                                              field="pinCode"
                                              [form]="employeeContactDataForm"
                                              [error]="{
                                                minLength: 'Pincode should have a minimum of 5 digits',
                                                maxLength: 'Pincode should not exceed 10 digits',
                                                pattern: 'Invalid Pincode format'
                                              }"
                                            >
                                            </app-validation>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-12 text-end mt-3">
                                      <button
                                        type="submit"
                                        class="btn-save"
                                        (click)="updateEmployeeContact()"
                                        [disabled]="employeeContactDataForm.invalid"
                                      >
                                        SAVE
                                      </button>
                                      <button
                                        type="submit"
                                        class="btn-discard"
                                        (click)="reset(employeeContactDataForm, initialContactData)"
                                      >
                                        DISCARD
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="v-pills-profile"
                          role="tabpanel"
                          aria-labelledby="v-pills-profile-tab"
                        >
                          <form [formGroup]="employmentBasicDataForm">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="col-4">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label">Department</label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        formControlName="departmentName"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label">Branch Name</label>
                                      <input type="text" class="form-control" placeholder="" formControlName="branch" />
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label">Designation</label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        formControlName="designation"
                                      />
                                      <!--<app-validation
                                        field="designation"
                                        [form]="employmentBasicDataForm"
                                        [error]="{
                                          minLength: 'Designation should have a minimum of 5 characters',
                                          maxLength: 'Designation should not exceed 30 characters',
                                          pattern: 'Designation should contain only alphabets and spaces'
                                        }"
                                      >
                                      </app-validation>-->
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label"
                                        >Employment Category <sup>*</sup></label
                                      >
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        formControlName="category"
                                      />
                                    </div>
                                  </div>
                                  <div class="col-4">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label">Location</label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        formControlName="location"
                                      />
                                    </div>
                                  </div>
                                </div>
                                <!--<div class="col-12 text-end mt-3">
                                  <button type="submit" class="btn-save" (click)='updateEmploymentBasicData()' [disabled]="employmentBasicDataForm.invalid">SAVE</button>
                                  <button type="submit" class="btn-discard" (click)='reset(employmentBasicDataForm, initialEmploymentBasicData)'>DISCARD</button>
                                </div>-->
                              </div>
                            </div>
                          </form>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="v-pills-messages"
                          role="tabpanel"
                          aria-labelledby="v-pills-messages-tab"
                        >
                          <form [formGroup]="statutoryDetailsForm">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="col-6">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label">P.F. No.</label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        formControlName="pfNumber"
                                        [ngClass]="{
                                          'is-invalid':
                                            statutoryData_f['pfNumber'].errors && statutoryData_f['pfNumber'].touched
                                        }"
                                      />
                                      <app-validation
                                        field="pfNumber"
                                        [form]="statutoryDetailsForm"
                                        [error]="{
                                          minLength: 'PF number must contain exactly 22 alphanumeric characters',
                                          maxLength: 'PF number must contain exactly 22 alphanumeric characters',
                                          pattern:
                                            'Invalid PF number. The PF number should have exactly 22 alphanumeric characters'
                                        }"
                                      >
                                      </app-validation>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label">UAN No.</label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        formControlName="uanNumber"
                                        [ngClass]="{
                                          'is-invalid':
                                            statutoryData_f['uanNumber'].errors && statutoryData_f['uanNumber'].touched
                                        }"
                                      />
                                      <app-validation
                                        field="uanNumber"
                                        [form]="statutoryDetailsForm"
                                        [error]="{
                                          minLength: 'UAN number should contain 12 digits',
                                          maxLength: 'UAN number should contain 12 digits',
                                          pattern: 'Invalid UAN format, should contain only numbers'
                                        }"
                                      >
                                      </app-validation>
                                    </div>
                                  </div>
                                </div>

                                <div class="row">
                                  <div class="col-6">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label">PAN <sup>*</sup></label>
                                      <input
                                        type="text"
                                        class="form-control"
                                        id="exampleFormControlInput1"
                                        placeholder=""
                                        formControlName="pan"
                                        [ngClass]="{
                                          'is-invalid': statutoryData_f['pan'].errors && statutoryData_f['pan'].touched
                                        }"
                                      />
                                      <app-validation
                                        field="pan"
                                        [form]="statutoryDetailsForm"
                                        [error]="{
                                          required: 'This is a mandatory field, Kindly enter PAN number',
                                          pattern: 'Invalid PAN format',
                                          minLength: 'PAN number should contain 10 digits',
                                          maxLength: 'PAN number should contain 10 digits'
                                        }"
                                      >
                                      </app-validation>
                                    </div>
                                  </div>
                                  <div class="col-6">
                                    <div class="mb-3">
                                      <label for="exampleFormControlInput1" class="form-label"
                                        >Aadhaar Number <sup>*</sup></label
                                      >
                                      <input
                                        type="text"
                                        class="form-control"
                                        placeholder=""
                                        formControlName="aadhaar"
                                        [ngClass]="{
                                          'is-invalid':
                                            statutoryData_f['aadhaar'].errors && statutoryData_f['aadhaar'].touched
                                        }"
                                      />
                                      <app-validation
                                        field="aadhaar"
                                        [form]="statutoryDetailsForm"
                                        [error]="{
                                          required: 'This is a mandatory field, Kindly enter Aadhaar number',
                                          pattern: 'Invalid Aadhaar format',
                                          minLength: 'Aadhaar number should contain 12 digits',
                                          maxLength: 'Aadhaar number should contain 12 digits'
                                        }"
                                      >
                                      </app-validation>
                                    </div>
                                  </div>
                                </div>
                                <!--<div class="col-12 text-end mt-3">
                                  <button type="submit" class="btn-save" (click)="updateStatutoryDetails()"
                                          [disabled]="statutoryDetailsForm.invalid">SAVE
                                  </button>
                                  <button type="submit" class="btn-discard"
                                          (click)="reset(statutoryDetailsForm, initialStatutoryDetails)">DISCARD
                                  </button>
                                </div>-->
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
